import { render, staticRenderFns } from "./AlarmRecords.vue?vue&type=template&id=e2dc04e0&scoped=true"
import script from "./AlarmRecords.vue?vue&type=script&lang=js"
export * from "./AlarmRecords.vue?vue&type=script&lang=js"
import style0 from "./AlarmRecords.vue?vue&type=style&index=0&id=e2dc04e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2dc04e0",
  null
  
)

export default component.exports